import { getRequest, patchRequest, postRequest } from 'helper/request';
import { setURLParam } from 'helper/url';

class BomHelper {
  constructor({
    getPath, updatePath, bulkUpdatePath, refreshPath, pricePath, searchPath, statusPath,
  }) {
    this.getPath = getPath;
    this.updatePath = updatePath;
    this.bulkUpdatePath = bulkUpdatePath;
    this.refreshPath = refreshPath;
    this.pricePath = pricePath;
    this.searchPath = searchPath;
    this.statusPath = statusPath;
  }

  async fetch() {
    return getRequest(this.getPath);
  }

  async fetchPrices(quantity) {
    const endpoint = setURLParam('quantity', quantity, this.pricePath);
    return getRequest(endpoint);
  }

  async fetchStatus() {
    return getRequest(this.statusPath);
  }

  async updateMpnPropertyKey(mpnPropertyKey) {
    return patchRequest(this.updatePath, { data: { bom: { mpn_property_key: mpnPropertyKey } } });
  }

  async excludeParts(parts, excluded) {
    return this.bulkUpdate(parts, { excluded });
  }

  // Choosing a sourcing places the part again if it was excluded
  async setSourcing(parts, customerSupplied) {
    return this.bulkUpdate(parts, { excluded: false, customer_supplied: customerSupplied });
  }

  async confirmParts(parts) {
    return this.bulkUpdate(parts, { action: 'confirm' });
  }

  async unassignParts(parts) {
    return this.bulkUpdate(parts, { action: 'unassign' });
  }

  async bulkUpdate(parts, payload) {
    const updatePayload = parts.map((p) => ({
      id: p.id,
      ...payload,
    }));
    return patchRequest(this.bulkUpdatePath, { data: { bom_parts: updatePayload } });
  }

  async refreshPrices() {
    return postRequest(this.refreshPath);
  }

  async search(
    searchTerm,
    name,
    forceSearch,
    distributorSearch,
    footprint,
  ) {
    const query = {
      q: searchTerm.trim(),
      name,
      force_search: forceSearch,
      distributor_search: distributorSearch,
    };
    if (footprint != null) query.footprint = footprint;

    return getRequest(this.searchPath, {
      query,
    });
  }
}

export default BomHelper;
